import {FC} from 'react'
import { printDateTime } from "../../../../../../../utils/dateHelpers";

type Props = {
  date?: string
}

const VerificationDate: FC<Props> = ({date}) => (
  //<div className='badge badge-light fw-bolder'>{applicationDate}</div>
  <>{printDateTime(date)}</>
)

export {VerificationDate}
